var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createAutocomplete, } from '@algolia/autocomplete-core';
import React from 'react';
import { ClearIcon } from './ClearIcon';
import { SearchIcon } from './SearchIcon';
import { itemToBins } from '../../data/bins';
import { useHistory } from 'react-router-dom';
export function Autocomplete(props) {
    var _a = React.useState({
        collections: [],
        completion: null,
        context: {},
        isOpen: false,
        query: '',
        activeItemId: null,
        status: 'idle',
    }), autocompleteState = _a[0], setAutocompleteState = _a[1];
    var autocomplete = React.useMemo(function () {
        return createAutocomplete(__assign({ onStateChange: function (_a) {
                var state = _a.state;
                setAutocompleteState(state);
            }, getSources: function () {
                return [
                    {
                        sourceId: 'links',
                        getItems: function (_a) {
                            var query = _a.query;
                            return itemToBins.filter(function (_a) {
                                var item = _a.item;
                                return item.toLowerCase().includes(query.toLowerCase());
                            });
                        },
                        getItemUrl: function (_a) {
                            var item = _a.item;
                            return item.id; // todo: make ids as string
                        },
                    },
                ];
            } }, props));
    }, [props]);
    var inputRef = React.useRef(null);
    var formRef = React.useRef(null);
    var panelRef = React.useRef(null);
    var getEnvironmentProps = autocomplete.getEnvironmentProps;
    var history = useHistory();
    var onResultClick = function (item) {
        history.push("/" + item.id);
        inputRef.current.blur();
        panelRef.current.hidden = true;
    };
    React.useEffect(function () {
        if (!formRef.current || !panelRef.current || !inputRef.current) {
            return undefined;
        }
        var _a = getEnvironmentProps({
            formElement: formRef.current,
            inputElement: inputRef.current,
            panelElement: panelRef.current,
        }), onTouchStart = _a.onTouchStart, onTouchMove = _a.onTouchMove;
        window.addEventListener('touchstart', onTouchStart);
        window.addEventListener('touchmove', onTouchMove);
        return function () {
            window.removeEventListener('touchstart', onTouchStart);
            window.removeEventListener('touchmove', onTouchMove);
        };
    }, [getEnvironmentProps, formRef, inputRef, panelRef]);
    return (React.createElement("div", __assign({ className: 'aa-Autocomplete' }, autocomplete.getRootProps({})),
        React.createElement("form", __assign({ ref: formRef, className: 'aa-Form' }, autocomplete.getFormProps({ inputElement: inputRef.current })),
            React.createElement("div", { className: 'aa-InputWrapperPrefix' },
                React.createElement("label", __assign({ className: 'aa-Label' }, autocomplete.getLabelProps({})),
                    React.createElement("button", { className: 'aa-SubmitButton', type: 'submit', title: 'Submit' },
                        React.createElement(SearchIcon, null)))),
            React.createElement("div", { className: 'aa-InputWrapper' },
                React.createElement("input", __assign({ className: 'aa-Input', ref: inputRef }, autocomplete.getInputProps({ inputElement: inputRef.current })))),
            React.createElement("div", { className: 'aa-InputWrapperSuffix' },
                React.createElement("button", { className: 'aa-ClearButton', title: 'Clear', type: 'reset' },
                    React.createElement(ClearIcon, null)))),
        autocompleteState.isOpen && (React.createElement("div", __assign({ ref: panelRef, className: [
                'aa-Panel',
                'aa-Panel--desktop',
                autocompleteState.status === 'stalled' && 'aa-Panel--stalled',
            ]
                .filter(Boolean)
                .join(' ') }, autocomplete.getPanelProps({})),
            React.createElement("div", { className: 'aa-PanelLayout aa-Panel--scrollable' }, autocompleteState.collections.map(function (collection, index) {
                var source = collection.source, items = collection.items;
                return (React.createElement("section", { key: "source-" + index, className: 'aa-Source' }, items.length > 0 && (React.createElement("ul", __assign({ className: 'aa-List' }, autocomplete.getListProps()), items.map(function (item) {
                    return (React.createElement("li", __assign({ key: item.item, className: 'aa-Item' }, autocomplete.getItemProps({ item: item, source: source }), { onClick: function () { return onResultClick(item); } }),
                        React.createElement("div", { className: 'aa-ItemWrapper' },
                            React.createElement("div", { className: 'aa-ItemContent' },
                                React.createElement("div", { className: 'aa-ItemContentBody' },
                                    React.createElement("div", { className: 'aa-ItemContentTitle', dangerouslySetInnerHTML: {
                                            __html: item.item,
                                        } }))),
                            React.createElement("div", { className: 'aa-ItemActions' },
                                React.createElement("button", { className: 'aa-ItemActionButton aa-DesktopOnly aa-ActiveOnly', type: 'button', title: 'Select', style: { pointerEvents: 'none' } },
                                    React.createElement("svg", { fill: 'currentColor', viewBox: '0 0 24 24' },
                                        React.createElement("path", { d: 'M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z' })))))));
                })))));
            }))))));
}
